// extracted by mini-css-extract-plugin
module.exports = {"description":"contacts_description__Afa4s","link":"contacts_link__PySwZ","image":"contacts_image__zECLe","grid":"contacts_grid__3P4OF"};